import { ReactComponent as ProfileIcon } from './profile.svg';

export default ProfileIcon;
